/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MaterialReactTable } from "material-react-table";
import { Box, IconButton, TextField, InputAdornment } from "@mui/material";
import SaveIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Close";
import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/PatientManagementHelper/PatientManagementHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import ImmunizationsHeader from "./Header/ImmunizationsHeader";
import {
  getDateFormatInSpanish,
  mergeListById,
} from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { assetImages } from "constants";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AssignUserModal from "components/Common/Modal/AssignUserModal";
import ImmunizationFilter from "./Popup/ImmunizationFilter";
import SaveImmunizationPopup from "components/Common/Popup/SaveImmunizationPopup";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import AddLabelModal from "components/Common/Modal/AddLabelModal";

const ImmunizationsListBody = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const [isLoading, setIsLoading] = useState(false);
  const [immunizationList, setImmunizationList] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [selectedImmunizationIds, setSelectedImmunizationIds] = useState([]);
  const [selectedImmunizationId, setSelectedImmunizationId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);
  const [isDataReady, setIsDataReady] = useState(false);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // Get all immunizations
  const getAllImmunizations = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_IMMUNIZATION + `?token=${token}`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl = requestUrl + `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("requestUrl", requestUrl);
      const response = await getData(requestUrl);
      console.log("response in immunization list------->", response);
      setIsLoading(false);
      if (response.status) {
        setImmunizationList(response.data);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  // Bulk update immunizations
  const updateBulkImmunizationHandler = async () => {
    if (selectedImmunizationIds.length > 0) {
      try {
        const immunizationListToBeUpdate = immunizationList
          .filter((item) => selectedImmunizationIds.includes(item._id))
          .map((item) => ({
            _id: item._id,
            vaccinename: item.vaccinename,
            dateadministered: item.dateadministered,
            dosenumber: item.dosenumber,
            status: item.status,
            administeredby: item.administeredby,
            facility: item.facility,
            batchnumber: item.batchnumber,
            sideeffects: item.sideeffects,
            assignto: item.assignto,
          }));
        let immunizationData = { immunizationlist: immunizationListToBeUpdate };
        let requestURL =
          url.API_BASE_URL +
          url.API_UPDATE_BULK_IMMUNIZATION +
          `?token=${token}`;
        const response = await putData(requestURL, immunizationData);

        console.log("response in update bulk immunization handler", response);
        if (response.status) {
          setMessageType("success");
          setTimeout(() => {
            setSelectedImmunizationIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }
        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one immunization");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  // Bulk delete immunizations
  const deleteBulkImmunizationHandler = async () => {
    if (selectedImmunizationIds.length > 0) {
      try {
        const immunizationListToBeDelete = immunizationList.filter((item) =>
          selectedImmunizationIds.includes(item._id)
        );
        let immunizationData = { immunizationlist: immunizationListToBeDelete };
        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_IMMUNIZATION +
          `?token=${token}`;
        const response = await putData(requestURL, immunizationData);
        if (response.status) {
          setMessageType("success");
          setTimeout(() => {
            setImmunizationList((prevList) =>
              prevList.filter(
                (item) => !selectedImmunizationIds.includes(item._id)
              )
            );
            setSelectedImmunizationIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }
        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one immunization");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for remove tag from immunization
  const removeTagFromImmunization = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_IMMUNIZATION;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedImmunizationId(null);
      }, 1000);
    }
  };

  // After any action
  const afterActionClose = (data = []) => {
    setImmunizationList((prevList) => mergeListById(prevList, data));
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllImmunizations();
      setIsDataReady(true);
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllImmunizations();
      setReloadData(false);
      setIsDataReady(true);
    }
  }, [reloadData]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveImmunizationOffCanvas"
            aria-controls="saveImmunizationOffCanvas"
            onClick={() => {
              setSelectedImmunizationId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false,
        enableColumnDragging: false,
        enableSorting: false,
      },
      {
        header: "Vaccine",
        accessorKey: "vaccinename",
        size: 200,
        Cell: ({ row }) => (
          <div
            className={
              row.original.vaccinename === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.vaccineimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.vaccineimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.vaccinename}</span>
            </p>
          </div>
        ),
      },
      {
        accessorKey: "tagstring",
        header: t("Label"),
        size: 200,
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.taglist.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.taglist.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedImmunizationId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromImmunization(
                              [tag._id],
                              row.original._id
                            );
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedImmunizationId &&
                          selectedImmunizationId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedImmunizationIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        header: "Vaccination For",
        accessorKey: "title",
        size: 160,
      },
      {
        header: "Administered By",
        accessorKey: "doctorname",
        size: 180,
        Cell: ({ row }) => (
          <div
            className={
              row.original.doctorname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.doctorimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.doctorimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.doctorname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Assigned To",
        accessorKey: "assignedpersonname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.assignedpersonname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.assignedpersonimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.assignedpersonimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.assignedpersonname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Facility",
        accessorKey: "clinicname",
        size: 250,
        Cell: ({ row }) => (
          <div
            className={
              row.original.clinicname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.clinicimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.clinicimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.clinicname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Date Administered",
        accessorKey: "administereddate",
        size: 160,
      },
      {
        header: "Dose Number",
        accessorKey: "dosenumber",
        size: 120,
      },
      {
        header: "Batch Number",
        accessorKey: "batchnumber",
        size: 120,
      },
    ],
    [selectedTagId, selectedImmunizationId]
  );

  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    setSelectedImmunizationIds(selectedIdsArray);
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_PATIENT_MANAGEMENT") &&
      moduleAccess.includes("MOD_IMMUNIZATION_MANAGEMENT"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Vaccinations")}
          />
          <div className="container-fluid px-lg-5">
            <ImmunizationsHeader
              reloadList={resetFilterData}
              selectedItemIds={selectedImmunizationIds}
              updateBulkHandler={updateBulkImmunizationHandler}
              jsonFilterQuery={jsonFilterQuery}
            />
            {isLoading || !isDataReady ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={immunizationList}
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder }}
                  initialState={{ rowSelection, columnOrder }}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50,
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
          {/* popup and modals */}

          <SaveImmunizationPopup
            selectedImmunizationId={selectedImmunizationId}
            setSelectedImmunizationId={setSelectedImmunizationId}
            afterPopupClose={afterActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <ImmunizationFilter
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={resetFilterData}
            moduleSlug="immunization"
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
            columnOrder={columnOrder}
          />

          <AssignUserModal
            moduleName="immunization"
            afterModalClose={afterActionClose}
            selectedIds={selectedImmunizationIds}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setRowSelection({});
              setSelectedImmunizationIds([]);
            }}
          />

          <AddLabelModal
            moduleName="immunization"
            selectedIds={selectedImmunizationIds}
            afterTagModalClose={afterActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setRowSelection({});
              setSelectedImmunizationIds([]);
            }}
          />

          <DeleteWarningModal
            onDelete={deleteBulkImmunizationHandler}
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedImmunizationIds([]);
            }}
            moduleName={t("immunization")}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default ImmunizationsListBody;
